var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: _vm.value } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("carpass-observation-select-activity"))),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          items: _vm.mainActivityItems,
                          label: _vm.$ct("carpass-main-activity"),
                        },
                        model: {
                          value: _vm.selectedMainActivity,
                          callback: function ($$v) {
                            _vm.selectedMainActivity = $$v
                          },
                          expression: "selectedMainActivity",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        style: { flexGrow: 1 },
                        attrs: {
                          fancy: "",
                          items: _vm.subActivityItems,
                          label: _vm.$ct("carpass-sub-activity"),
                        },
                        model: {
                          value: _vm.selectedSubActivity,
                          callback: function ($$v) {
                            _vm.selectedSubActivity = $$v
                          },
                          expression: "selectedSubActivity",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check", disabled: !_vm.isValid },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }